import {
  BookOpen,
  ChartNoAxesColumn,
  Filter,
  ImageUp,
  Mail,
  MessageSquareText,
  Package,
  Settings,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    label: "Produktion",
    items: [
      { to: "/orders", label: "Bestellungen", icon: Package },
      { to: "/books", label: "Bücher", icon: BookOpen },
      { to: "/prompts", label: "Prompts", icon: MessageSquareText },
      { to: "/mail-templates", label: "Mailvorlagen", icon: Mail },
    ],
  },
  {
    label: "Analytics",
    items: [
      { to: "/overview", label: "Übersicht", icon: ChartNoAxesColumn },
      { to: "/funnel", label: "Funnel", icon: Filter },
      { to: "/uploads", label: "Uploads", icon: ImageUp },
    ],
  },
];

export const SETTINGS_ITEM: NavItem = {
  to: "/settings",
  label: "Einstellungen",
  icon: Settings,
};

// Betriebsanleitung „neues Buch anlegen“ — von der API selbst ausgeliefert,
// deshalb ein echter Link statt einer SPA-Route.
export const HELP_URL = "/api/help";
export const HELP_LABEL = "Anleitung: Neues Buch";
